if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.find(
          (variant) => variant.id === evt.detail.variant.id
        );

        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );

        // Update delivery countdown for new variant
        updateDeliveryCountdown(inventory.inventory_quantity, inventory.inventory_policy);
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
        updateDeliveryCountdown(0, 'deny'); // Hide countdown
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        this.setAttribute('data-inventory-level', inventoryLevel);

        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel.includes('low')) {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;
          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}

// -------------------
// Delivery Countdown Logic (2PM Cutoff)
// -------------------

function updateDeliveryCountdown(inventoryQty, inventoryPolicy) {
  const countdownElement = document.querySelector('.js-inventory-countdown');
  if (!countdownElement) return;

  const isInStock = inventoryQty > 0 || inventoryPolicy !== 'continue';

  if (!isInStock) {
    countdownElement.innerHTML = ''; // Hide for pre-orders
    return;
  }

  const now = new Date();
  const day = now.getDay(); // 0 = Sunday, 6 = Saturday
  const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 0, 0); // ✅ 2PM cutoff
  const afterCutoff = now.getTime() >= cutoff.getTime();
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  let deliveryDate = new Date(now);

  // Delivery logic based on your rules
  switch (day) {
    case 0: // Sunday
      deliveryDate.setDate(now.getDate() + (afterCutoff ? 2 : 1)); // Tue or Mon
      break;
    case 6: // Saturday
      deliveryDate.setDate(now.getDate() + 2); // Always Monday
      break;
    case 5: // Friday
      deliveryDate.setDate(now.getDate() + 3); // Always Monday
      break;
    case 4: // Thursday
      deliveryDate.setDate(now.getDate() + (afterCutoff ? 4 : 1)); // Mon or Fri
      break;
    case 3: // Wednesday
      deliveryDate.setDate(now.getDate() + (afterCutoff ? 2 : 1)); // Fri or Thu
      break;
    case 2: // Tuesday
      deliveryDate.setDate(now.getDate() + (afterCutoff ? 2 : 1)); // Thu or Wed
      break;
    case 1: // Monday
      deliveryDate.setDate(now.getDate() + (afterCutoff ? 2 : 1)); // Wed or Tue
      break;
  }

  const deliveryDayName = dayNames[deliveryDate.getDay()];
  const deliveryDateFormatted = deliveryDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit'
  });

  function startCountdown(endTime) {
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance <= 0) {
        clearInterval(interval);
        countdownElement.innerHTML = `Order now for delivery on <strong>${deliveryDayName} ${deliveryDateFormatted}</strong>`;
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownElement.innerHTML = `Order within ${hours}h ${minutes}m ${seconds}s for <strong>Next Working Day Delivery</strong>`;
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
  }

  if (!afterCutoff && day >= 1 && day <= 4) {
    startCountdown(cutoff.getTime());
  } else {
    countdownElement.innerHTML = `Order now for delivery on <strong>${deliveryDayName} ${deliveryDateFormatted}</strong>`;
  }
}

// -------------------
// Run on First Load
// -------------------
document.addEventListener('DOMContentLoaded', function () {
  const productEl = document.querySelector('product-inventory');
  if (productEl) {
    const dataEl = productEl.querySelector('[type="application/json"]');
    if (dataEl) {
      const variants = JSON.parse(dataEl.textContent);
      const selectedVariant = variants.find(variant => variant.available);
      if (selectedVariant) {
        updateDeliveryCountdown(selectedVariant.inventory_quantity, selectedVariant.inventory_policy);
      }
    }
  }
});
